import * as React from 'react';
import { UserLoginLink } from '../user/login-link';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import {
  FlashMessageTypeError,
  FlashMessageTypeInfo,
  FlashMessageTypeMigrationPrompt,
  FlashMessageTypeNoUser,
  FlashMessageTypeOrderSuccess,
} from '../../types';

export interface FlashMessageSpec {
  (props?: any): {
    title: any;
    message: any;
    image: any;
  };
}

export const FlashMessages: { [type: string]: FlashMessageSpec } = {
  [FlashMessageTypeInfo]: ({ title, message, image }) => ({
    title,
    message,
    image,
  }),

  [FlashMessageTypeNoUser]: ({ message = 'to continue', redirectTo }) => ({
    title: <FormattedMessage id="flash.message.no_user.title" />,
    message: (
      <FormattedMessage
        tagName="div"
        id="flash.message.no_user.value"
        values={{
          link: <UserLoginLink firstPaint={false} noLogo={true} redirectTo={redirectTo} />,
          message,
        }}
      />
    ),
    image: null,
  }),

  [FlashMessageTypeOrderSuccess]: ({ orderId }) => ({
    title: <FormattedMessage id="flash.message.order_success.title" />,
    message: (
      <Link to={`/account/order/${orderId}`}>
        <FormattedMessage id="flash.message.order_success.value" />
      </Link>
    ),
    image: null,
  }),

  [FlashMessageTypeError]: () => ({
    title: <FormattedMessage id="flash.message.error.title" />,
    message: <FormattedMessage id="flash.message.error.message" />,
    image: null,
  }),

  [FlashMessageTypeMigrationPrompt]: ({ onClickPrompt }) => ({
    title: <FormattedMessage id="flash.message.migration.title" />,
    message: (
      <a href="#" onClick={onClickPrompt}>
        <FormattedMessage id="flash.message.migration.prompt" />
      </a>
    ),
    image: null,
  }),
};
